// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

//This function replaces a normal hyphen by a non-breaking hyphen.
export const hyphenConverter = (text) => text.replace(/\u002d/g, "\u2011");
